module.exports = __webpack_public_path__ + "img/roulette-top.ca3ec13e.png";